<div class="container-fluid">
  <div class="row mt-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Checklists Disponíveis</h4>
        </div>
        <div class="card-body">
          <table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome do Formulário</th>
                <th>Status</th>
                <th>Data Início</th>
                <th>Data Fim</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let checklist of checklists">
                <td>{{ checklist.id }}</td>
                <td>{{ checklist.nomeFormulario }}</td>
                <td>
                  <span [class]="'badge ' + getStatusClass(checklist.status)">
                    {{ checklist.status }}
                  </span>
                </td>
                <td>{{ checklist.dataInicio | date:'dd/MM/yyyy' }}</td>
                <td>{{ checklist.dataFim | date:'dd/MM/yyyy' }}</td>
                <td>
                  <button *ngIf="podeResponder(checklist.status)" 
                          class="btn btn-sm btn-primary" 
                          (click)="responderChecklist(checklist)">
                    <i class="feather icon-edit-2 mr-1"></i>
                    Responder
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div> 